import React from 'react';
export var CookieContext = React.createContext({ rawCookie: '' });
export var CookieProvider = function (_a) {
    var cookies = _a.cookies, rawCookie = _a.rawCookie, children = _a.children;
    return React.createElement(CookieContext.Provider, { value: { cookies: cookies, rawCookie: rawCookie } }, children);
};
//# sourceMappingURL=cookie.js.map